<template>
  <div>
    <AlertErrorMsg
      ref="alert"
      :title="errorMessage"
      class="page-alert-error"
    />
    <HeaderMyProfile :firm="firmData" @updateProfile="getFirmData" @showError="errorMessage = $event" />
    <div v-if="firmData && firmData.companyOwner" class="primary-contact-wrapper">
      <h2>Primary contact</h2>
      <div class="contact-name-wrapper">
        <div class="contact-name">
          <svg
            width="32"
            height="33"
            viewBox="0 0 32 33"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M21.5 15.5C21.5 16.5878 21.1774 17.6512 20.5731 18.5556C19.9687 19.4601 19.1098 20.1651 18.1048 20.5813C17.0998 20.9976 15.9939 21.1065 14.927 20.8943C13.8601 20.6821 12.8801 20.1583 12.1109 19.3891C11.3417 18.6199 10.8179 17.6399 10.6057 16.573C10.3935 15.5061 10.5024 14.4002 10.9187 13.3952C11.335 12.3902 12.0399 11.5313 12.9444 10.9269C13.8488 10.3226 14.9122 10 16 10C17.4582 10.0017 18.8562 10.5816 19.8873 11.6127C20.9184 12.6438 21.4984 14.0418 21.5 15.5ZM29 16.5C29 19.0712 28.2376 21.5846 26.8091 23.7224C25.3807 25.8603 23.3503 27.5265 20.9749 28.5104C18.5995 29.4944 15.9856 29.7518 13.4638 29.2502C10.9421 28.7486 8.6257 27.5105 6.80762 25.6924C4.98953 23.8743 3.75141 21.5579 3.2498 19.0362C2.74819 16.5144 3.00563 13.9006 3.98957 11.5251C4.97351 9.14968 6.63975 7.11935 8.77759 5.6909C10.9154 4.26244 13.4288 3.5 16 3.5C19.4467 3.50364 22.7512 4.87445 25.1884 7.31163C27.6256 9.74882 28.9964 13.0533 29 16.5ZM27 16.5C26.9984 15.0194 26.6982 13.5544 26.1174 12.1924C25.5366 10.8305 24.6871 9.59974 23.6198 8.57367C22.5524 7.54759 21.289 6.74732 19.9053 6.2207C18.5215 5.69408 17.0457 5.45194 15.5663 5.50875C9.67876 5.73625 4.98376 10.64 5.00001 16.5312C5.00565 19.2132 5.99478 21.7998 7.78001 23.8013C8.50703 22.7468 9.43056 21.8423 10.5 21.1375C10.5912 21.0773 10.6996 21.0486 10.8086 21.0558C10.9177 21.063 11.0213 21.1058 11.1038 21.1775C12.4627 22.3529 14.1995 22.9998 15.9963 22.9998C17.793 22.9998 19.5298 22.3529 20.8888 21.1775C20.9712 21.1058 21.0749 21.063 21.1839 21.0558C21.2929 21.0486 21.4013 21.0773 21.4925 21.1375C22.5633 21.842 23.4881 22.7464 24.2163 23.8013C26.0103 21.7925 27.0013 19.1932 27 16.5Z"
              fill="black"
            />
          </svg>
          <p>
            {{
              capitalizeFirstLetter(firmData.companyOwner.firstName) + ' '
                + capitalizeFirstLetter(firmData.companyOwner.lastName)
            }}
          </p>
        </div>
        <button
          id="button_change_primary_contact"
          class="btn btn-revert"
          @click="$refs.changePrimaryPopup.openPopups()"
        >
          Change Primary Contact
          <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_19979_50319)">
              <path
                d="M7.87529 11.7502C7.87529 10.9344 8.11722 10.1368 8.57048 9.45848C9.02374 8.78013 9.66798 8.25142 10.4217 7.93921C11.1755 7.62699 12.0049 7.54531 12.805 7.70447C13.6052 7.86363 14.3402 8.2565 14.9171 8.83339C15.494 9.41028 15.8869 10.1453 16.046 10.9455C16.2052 11.7456 16.1235 12.575 15.8113 13.3288C15.4991 14.0825 14.9704 14.7268 14.292 15.18C13.6137 15.6333 12.8161 15.8752 12.0003 15.8752C10.9063 15.8752 9.85706 15.4406 9.08348 14.667C8.30989 13.8934 7.87529 12.8442 7.87529 11.7502ZM19.7028 17.1108C19.5357 17.0138 19.3382 16.9832 19.1496 17.0251C18.961 17.0669 18.795 17.1782 18.6847 17.3368C18.5231 17.5594 18.3503 17.7737 18.1672 17.979C17.6215 17.187 16.9282 16.5077 16.1253 15.9783C16.0568 15.9329 15.9753 15.9113 15.8934 15.9167C15.8114 15.9221 15.7334 15.9543 15.6715 16.0083C14.6527 16.89 13.3504 17.3752 12.0031 17.3752C10.6558 17.3752 9.35351 16.89 8.33467 16.0083C8.27233 15.953 8.19332 15.92 8.11012 15.9145C8.02693 15.9091 7.9443 15.9316 7.87529 15.9783C7.07219 16.5067 6.37858 17.185 5.83248 17.9761C4.66122 16.6609 3.94346 15.0042 3.78498 13.2502H5.22873C5.35013 13.2521 5.47025 13.2253 5.57927 13.1718C5.68828 13.1184 5.78308 13.0398 5.85592 12.9427C5.96159 12.7982 6.01212 12.6207 5.99837 12.4423C5.98461 12.2638 5.90748 12.0962 5.78092 11.9696L3.53092 9.71958C3.46126 9.64985 3.37855 9.59453 3.2875 9.55679C3.19645 9.51904 3.09885 9.49962 3.00029 9.49962C2.90173 9.49962 2.80414 9.51904 2.71309 9.55679C2.62204 9.59453 2.53932 9.64985 2.46967 9.71958L0.219667 11.9696C0.0931004 12.0962 0.0159731 12.2638 0.00221867 12.4423C-0.0115358 12.6207 0.0389896 12.7982 0.144667 12.9427C0.217499 13.0398 0.312304 13.1184 0.421319 13.1718C0.530334 13.2253 0.650458 13.2521 0.771855 13.2502H2.27842C2.43181 15.2442 3.19465 17.1427 4.46352 18.6885C5.73238 20.2343 7.4459 21.3525 9.37175 21.8915C11.2976 22.4306 13.3426 22.3643 15.2296 21.7018C17.1165 21.0394 18.7541 19.8126 19.9203 18.188C19.9805 18.1043 20.0227 18.009 20.0444 17.9082C20.0661 17.8073 20.0667 17.7031 20.0463 17.602C20.0259 17.5009 19.9849 17.4051 19.9258 17.3206C19.8667 17.2361 19.7907 17.1647 19.7028 17.1108ZM23.9431 12.2133C23.8864 12.0763 23.7903 11.9591 23.6669 11.8767C23.5436 11.7943 23.3986 11.7502 23.2503 11.7502H21.7222C21.5688 9.75624 20.8059 7.85767 19.5371 6.31189C18.2682 4.76612 16.5547 3.64791 14.6288 3.10888C12.703 2.56986 10.658 2.63608 8.77102 3.29857C6.88408 3.96106 5.2465 5.18777 4.08029 6.8124C3.96418 6.97401 3.91702 7.17514 3.94919 7.37152C3.98137 7.56791 4.09024 7.74347 4.25185 7.85958C4.41347 7.9757 4.61459 8.02286 4.81098 7.99068C5.00737 7.95851 5.18293 7.84964 5.29904 7.68802C6.28021 6.32193 7.65547 5.28837 9.24054 4.72584C10.8256 4.16331 12.5447 4.09868 14.1676 4.54062C15.7904 4.98256 17.2394 5.90995 18.3203 7.19852C19.4013 8.48708 20.0626 10.0753 20.2156 11.7502H18.7503C18.6019 11.7501 18.4568 11.794 18.3333 11.8764C18.2099 11.9588 18.1136 12.076 18.0568 12.2131C18 12.3502 17.9852 12.5011 18.0141 12.6467C18.0431 12.7923 18.1147 12.9259 18.2197 13.0308L20.4697 15.2808C20.5393 15.3506 20.622 15.4059 20.7131 15.4436C20.8041 15.4814 20.9017 15.5008 21.0003 15.5008C21.0989 15.5008 21.1964 15.4814 21.2875 15.4436C21.3785 15.4059 21.4613 15.3506 21.5309 15.2808L23.7809 13.0308C23.8858 12.9259 23.9571 12.7922 23.986 12.6467C24.0149 12.5012 24 12.3504 23.9431 12.2133Z"
                fill="#082655"
              />
            </g>
            <defs>
              <clipPath id="clip0_19979_50319">
                <rect
                  width="24"
                  height="24"
                  fill="white"
                  transform="translate(0 0.5)"
                />
              </clipPath>
            </defs>
          </svg>
        </button>
      </div>
      <TableHeader>
        <div class="name">
          <div class="table-header-box">
            <UserIcon />
            <span class="header-table-text">Name</span>
          </div>
        </div>

        <div class="phone">
          <div class="table-header-box">
            <svg
              width="18"
              height="19"
              viewBox="0 0 18 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_19666_161152)">
                <path
                  d="M17.5097 13.7102L14.9978 11.1982C14.1007 10.3011 12.5756 10.66 12.2167 11.8262C11.9476 12.6337 11.0504 13.0822 10.243 12.9028C8.44877 12.4542 6.02653 10.1217 5.57796 8.23772C5.30883 7.43027 5.8471 6.53314 6.65452 6.26404C7.82078 5.90519 8.17963 4.38007 7.2825 3.48295L4.77055 0.970991C4.05285 0.343003 2.9763 0.343003 2.34831 0.970991L0.643768 2.67553C-1.06077 4.46978 0.823194 9.22455 5.03969 13.441C9.25618 17.6575 14.011 19.6313 15.8052 17.837L17.5097 16.1324C18.1378 15.4147 18.1378 14.3382 17.5097 13.7102Z"
                  fill="#D7DCE6"
                />
              </g>
              <defs>
                <clipPath id="clip0_19666_161152">
                  <rect
                    width="18"
                    height="18"
                    fill="white"
                    transform="translate(0 0.5)"
                  />
                </clipPath>
              </defs>
            </svg>
            <span class="header-table-text">Phone number</span>
          </div>
        </div>

        <div class="email">
          <div class="table-header-box">
            <EmailIcon />
            <span class="header-table-text">Email</span>
          </div>
        </div>
      </TableHeader>
      <div class="table-body">
        <div class="table-row">
          <div class="card">
            <div class="name">
              <div class="holder-info">
                <div class="img">
                  <img
                    v-if="firmData.companyOwner.avatar"
                    :src="firmData.companyOwner.avatar"
                    onerror="this.src='https://cdn4.iconfinder.com/data/icons/avatars-xmas-giveaway/128/girl_female_woman_avatar-512.png';"
                    alt=""
                  >
                  <img
                    v-else
                    src="https://cdn4.iconfinder.com/data/icons/avatars-xmas-giveaway/128/girl_female_woman_avatar-512.png"
                    alt=""
                  >
                </div>
                <div class="info">
                  <span
                    class="info-name"
                    v-text="capitalizeFirstLetter(firmData.companyOwner.firstName) + ' '
                      + capitalizeFirstLetter(firmData.companyOwner.lastName)"
                  />
                </div>
              </div>
            </div>

            <div class="phone">
              <div class="holder-info">
                <span class="info-name">{{ firmData.companyOwner.phoneNumber }}</span>
              </div>
            </div>

            <div class="email">
              <div class="holder-info">
                <span class="info-name">{{ firmData.companyOwner.email }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="firmData" class="primary-contact-wrapper">
      <h2>Billing contact</h2>
      <div class="contact-name-wrapper">
        <div class="contact-name">
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16 3C13.4288 3 10.9154 3.76244 8.77759 5.1909C6.63975 6.61935 4.97351 8.64968 3.98957 11.0251C3.00563 13.4006 2.74819 16.0144 3.2498 18.5362C3.75141 21.0579 4.98953 23.3743 6.80762 25.1924C8.6257 27.0105 10.9421 28.2486 13.4638 28.7502C15.9856 29.2518 18.5995 28.9944 20.9749 28.0104C23.3503 27.0265 25.3807 25.3603 26.8091 23.2224C28.2376 21.0846 29 18.5712 29 16C28.9964 12.5533 27.6256 9.24882 25.1884 6.81163C22.7512 4.37445 19.4467 3.00364 16 3ZM18 23H17V24C17 24.2652 16.8946 24.5196 16.7071 24.7071C16.5196 24.8946 16.2652 25 16 25C15.7348 25 15.4804 24.8946 15.2929 24.7071C15.1054 24.5196 15 24.2652 15 24V23H14C12.9391 23 11.9217 22.5786 11.1716 21.8284C10.4214 21.0783 10 20.0609 10 19C10 18.7348 10.1054 18.4804 10.2929 18.2929C10.4804 18.1054 10.7348 18 11 18C11.2652 18 11.5196 18.1054 11.7071 18.2929C11.8946 18.4804 12 18.7348 12 19C12 19.5304 12.2107 20.0391 12.5858 20.4142C12.9609 20.7893 13.4696 21 14 21H18C18.5304 21 19.0391 20.7893 19.4142 20.4142C19.7893 20.0391 20 19.5304 20 19C20 18.4696 19.7893 17.9609 19.4142 17.5858C19.0391 17.2107 18.5304 17 18 17H14.5C13.4391 17 12.4217 16.5786 11.6716 15.8284C10.9214 15.0783 10.5 14.0609 10.5 13C10.5 11.9391 10.9214 10.9217 11.6716 10.1716C12.4217 9.42143 13.4391 9 14.5 9H15V8C15 7.73478 15.1054 7.48043 15.2929 7.29289C15.4804 7.10536 15.7348 7 16 7C16.2652 7 16.5196 7.10536 16.7071 7.29289C16.8946 7.48043 17 7.73478 17 8V9H17.5C18.5609 9 19.5783 9.42143 20.3284 10.1716C21.0786 10.9217 21.5 11.9391 21.5 13C21.5 13.2652 21.3946 13.5196 21.2071 13.7071C21.0196 13.8946 20.7652 14 20.5 14C20.2348 14 19.9804 13.8946 19.7929 13.7071C19.6054 13.5196 19.5 13.2652 19.5 13C19.5 12.4696 19.2893 11.9609 18.9142 11.5858C18.5391 11.2107 18.0304 11 17.5 11H14.5C13.9696 11 13.4609 11.2107 13.0858 11.5858C12.7107 11.9609 12.5 12.4696 12.5 13C12.5 13.5304 12.7107 14.0391 13.0858 14.4142C13.4609 14.7893 13.9696 15 14.5 15H18C19.0609 15 20.0783 15.4214 20.8284 16.1716C21.5786 16.9217 22 17.9391 22 19C22 20.0609 21.5786 21.0783 20.8284 21.8284C20.0783 22.5786 19.0609 23 18 23Z"
              fill="black"
            />
          </svg>
          <p v-if="firmData.billingContact">
            {{
              capitalizeFirstLetter(firmData.billingContact.firstName) + ' '
                + capitalizeFirstLetter(firmData.billingContact.lastName)
            }}
          </p>
          <p v-else>
            No billing contact
          </p>
        </div>
        <button
          id="button_change_primary_contact"
          class="btn btn-revert"
          @click="$refs.changeBillingPopup.openPopups()"
        >
          Change Billing Contact
          <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_19979_50319)">
              <path
                d="M7.87529 11.7502C7.87529 10.9344 8.11722 10.1368 8.57048 9.45848C9.02374 8.78013 9.66798 8.25142 10.4217 7.93921C11.1755 7.62699 12.0049 7.54531 12.805 7.70447C13.6052 7.86363 14.3402 8.2565 14.9171 8.83339C15.494 9.41028 15.8869 10.1453 16.046 10.9455C16.2052 11.7456 16.1235 12.575 15.8113 13.3288C15.4991 14.0825 14.9704 14.7268 14.292 15.18C13.6137 15.6333 12.8161 15.8752 12.0003 15.8752C10.9063 15.8752 9.85706 15.4406 9.08348 14.667C8.30989 13.8934 7.87529 12.8442 7.87529 11.7502ZM19.7028 17.1108C19.5357 17.0138 19.3382 16.9832 19.1496 17.0251C18.961 17.0669 18.795 17.1782 18.6847 17.3368C18.5231 17.5594 18.3503 17.7737 18.1672 17.979C17.6215 17.187 16.9282 16.5077 16.1253 15.9783C16.0568 15.9329 15.9753 15.9113 15.8934 15.9167C15.8114 15.9221 15.7334 15.9543 15.6715 16.0083C14.6527 16.89 13.3504 17.3752 12.0031 17.3752C10.6558 17.3752 9.35351 16.89 8.33467 16.0083C8.27233 15.953 8.19332 15.92 8.11012 15.9145C8.02693 15.9091 7.9443 15.9316 7.87529 15.9783C7.07219 16.5067 6.37858 17.185 5.83248 17.9761C4.66122 16.6609 3.94346 15.0042 3.78498 13.2502H5.22873C5.35013 13.2521 5.47025 13.2253 5.57927 13.1718C5.68828 13.1184 5.78308 13.0398 5.85592 12.9427C5.96159 12.7982 6.01212 12.6207 5.99837 12.4423C5.98461 12.2638 5.90748 12.0962 5.78092 11.9696L3.53092 9.71958C3.46126 9.64985 3.37855 9.59453 3.2875 9.55679C3.19645 9.51904 3.09885 9.49962 3.00029 9.49962C2.90173 9.49962 2.80414 9.51904 2.71309 9.55679C2.62204 9.59453 2.53932 9.64985 2.46967 9.71958L0.219667 11.9696C0.0931004 12.0962 0.0159731 12.2638 0.00221867 12.4423C-0.0115358 12.6207 0.0389896 12.7982 0.144667 12.9427C0.217499 13.0398 0.312304 13.1184 0.421319 13.1718C0.530334 13.2253 0.650458 13.2521 0.771855 13.2502H2.27842C2.43181 15.2442 3.19465 17.1427 4.46352 18.6885C5.73238 20.2343 7.4459 21.3525 9.37175 21.8915C11.2976 22.4306 13.3426 22.3643 15.2296 21.7018C17.1165 21.0394 18.7541 19.8126 19.9203 18.188C19.9805 18.1043 20.0227 18.009 20.0444 17.9082C20.0661 17.8073 20.0667 17.7031 20.0463 17.602C20.0259 17.5009 19.9849 17.4051 19.9258 17.3206C19.8667 17.2361 19.7907 17.1647 19.7028 17.1108ZM23.9431 12.2133C23.8864 12.0763 23.7903 11.9591 23.6669 11.8767C23.5436 11.7943 23.3986 11.7502 23.2503 11.7502H21.7222C21.5688 9.75624 20.8059 7.85767 19.5371 6.31189C18.2682 4.76612 16.5547 3.64791 14.6288 3.10888C12.703 2.56986 10.658 2.63608 8.77102 3.29857C6.88408 3.96106 5.2465 5.18777 4.08029 6.8124C3.96418 6.97401 3.91702 7.17514 3.94919 7.37152C3.98137 7.56791 4.09024 7.74347 4.25185 7.85958C4.41347 7.9757 4.61459 8.02286 4.81098 7.99068C5.00737 7.95851 5.18293 7.84964 5.29904 7.68802C6.28021 6.32193 7.65547 5.28837 9.24054 4.72584C10.8256 4.16331 12.5447 4.09868 14.1676 4.54062C15.7904 4.98256 17.2394 5.90995 18.3203 7.19852C19.4013 8.48708 20.0626 10.0753 20.2156 11.7502H18.7503C18.6019 11.7501 18.4568 11.794 18.3333 11.8764C18.2099 11.9588 18.1136 12.076 18.0568 12.2131C18 12.3502 17.9852 12.5011 18.0141 12.6467C18.0431 12.7923 18.1147 12.9259 18.2197 13.0308L20.4697 15.2808C20.5393 15.3506 20.622 15.4059 20.7131 15.4436C20.8041 15.4814 20.9017 15.5008 21.0003 15.5008C21.0989 15.5008 21.1964 15.4814 21.2875 15.4436C21.3785 15.4059 21.4613 15.3506 21.5309 15.2808L23.7809 13.0308C23.8858 12.9259 23.9571 12.7922 23.986 12.6467C24.0149 12.5012 24 12.3504 23.9431 12.2133Z"
                fill="#082655"
              />
            </g>
            <defs>
              <clipPath id="clip0_19979_50319">
                <rect
                  width="24"
                  height="24"
                  fill="white"
                  transform="translate(0 0.5)"
                />
              </clipPath>
            </defs>
          </svg>
        </button>
      </div>
      <TableHeader v-if="firmData.billingContact">
        <div class="name">
          <div class="table-header-box">
            <UserIcon />
            <span class="header-table-text">Name</span>
          </div>
        </div>

        <div class="phone">
          <div class="table-header-box">
            <svg
              width="18"
              height="19"
              viewBox="0 0 18 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_19666_161152)">
                <path
                  d="M17.5097 13.7102L14.9978 11.1982C14.1007 10.3011 12.5756 10.66 12.2167 11.8262C11.9476 12.6337 11.0504 13.0822 10.243 12.9028C8.44877 12.4542 6.02653 10.1217 5.57796 8.23772C5.30883 7.43027 5.8471 6.53314 6.65452 6.26404C7.82078 5.90519 8.17963 4.38007 7.2825 3.48295L4.77055 0.970991C4.05285 0.343003 2.9763 0.343003 2.34831 0.970991L0.643768 2.67553C-1.06077 4.46978 0.823194 9.22455 5.03969 13.441C9.25618 17.6575 14.011 19.6313 15.8052 17.837L17.5097 16.1324C18.1378 15.4147 18.1378 14.3382 17.5097 13.7102Z"
                  fill="#D7DCE6"
                />
              </g>
              <defs>
                <clipPath id="clip0_19666_161152">
                  <rect
                    width="18"
                    height="18"
                    fill="white"
                    transform="translate(0 0.5)"
                  />
                </clipPath>
              </defs>
            </svg>
            <span class="header-table-text">Phone number</span>
          </div>
        </div>

        <div class="email">
          <div class="table-header-box">
            <EmailIcon />
            <span class="header-table-text">Email</span>
          </div>
        </div>
      </TableHeader>
      <div v-if="firmData.billingContact" class="table-body">
        <div class="table-row">
          <div class="card">
            <div class="name">
              <div class="holder-info">
                <div class="img">
                  <img
                    v-if="firmData.billingContact.avatar"
                    :src="firmData.billingContact.avatar"
                    onerror="this.src='https://cdn4.iconfinder.com/data/icons/avatars-xmas-giveaway/128/girl_female_woman_avatar-512.png';"
                    alt=""
                  >
                  <img
                    v-else
                    src="https://cdn4.iconfinder.com/data/icons/avatars-xmas-giveaway/128/girl_female_woman_avatar-512.png"
                    alt=""
                  >
                </div>
                <div class="info">
                  <span
                    class="info-name"
                    v-text="capitalizeFirstLetter(firmData.billingContact.firstName) + ' '
                      + capitalizeFirstLetter(firmData.billingContact.lastName)"
                  />
                </div>
              </div>
            </div>

            <div class="phone">
              <div class="holder-info">
                <span class="info-name">{{ firmData.billingContact.phoneNumber }}</span>
              </div>
            </div>

            <div class="email">
              <div class="holder-info">
                <span class="info-name">{{ firmData.billingContact.email }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="holder-profile-form form-content">
      <h2>Company information</h2>
      <p>If you need to update your company information just enter a new one and save</p>
      <form class="profile-form" @submit.prevent="submit">
        <div
          id="manage_system_settings-name"
          ref="manageSystemSettingsName"
          class="form-group"
          :class="{ 'form-group--error': $v.formData.firmName.$error }"
        >
          <label for="firm_edit-name_input">Company Name*</label>
          <input
            id="firm_edit-name_input"
            v-model.trim="$v.formData.firmName.$model"
            type="text"
            class="form-control"
            :disabled="!isThereManageSystemPermission"
            placeholder="Enter company name"
            :maxlength="firmNameMax"
          >
          <div v-if="firmNameError" class="error custom-error">
            {{ firmNameError }}
          </div>
          <div v-if="!$v.formData.firmName.required" class="error">
            Field is required
          </div>
          <div v-if="!$v.formData.firmName.minLength" class="error">
            Company name must have at least1
            {{ $v.formData.firmName.$params.minLength.min }} letters.
          </div>
          <div v-if="!$v.formData.firmName.maxLength" class="error">
            Company name must have no more than
            {{ $v.formData.firmName.$params.maxLength.max }} letters.
          </div>
          <tooltip v-if="!isThereManageSystemPermission" :target-ref="$refs.manageSystemSettingsName">
            <span>For access to update company information - you need to have the permission 'Manage system settings'</span>
          </tooltip>
        </div>
        <div
          id="manage_system_settings-country"
          ref="manageSystemSettingsCountry"
          class="form-group"
          :class="{ 'form-group--error': $v.formData.country.$error }"
        >
          <label for="firm_edit-country_input">Country*</label>
          <custom-select-geolocation
            id="firm_edit-country_input"
            ref="selectCountry"
            :options="countries"
            :custom-id="'countries-item'"
            :class="isThereManageSystemPermission ? '' : 'disabled'"
            default="Select a country"
            @input="selectCountry"
            @openSelect="closeOtherSelectFields($refs.selectCountry)"
          />
          <select
            v-show="false"
            v-model="$v.formData.country.$model"
            class="form-control"
          >
            <option selected value disabled>
              Select a country
            </option>
            <option
              v-for="(country, indx) in countries"
              :key="indx"
              :value="country.iso2"
            >
              {{ country.name }}
            </option>
          </select>
          <div v-if="countryError" class="error custom-error">
            {{ countryError }}
          </div>
          <div v-if="!$v.formData.country.required" class="error">
            Field is required
          </div>
          <tooltip v-if="!isThereManageSystemPermission" :target-ref="$refs.manageSystemSettingsCountry">
            <span>For access to update company information - you need to have the permission 'Manage system settings'</span>
          </tooltip>
        </div>
        <div
          id="manage_system_settings-state"
          ref="manageSystemSettingsState"
          class="form-group"
          :class="{ 'form-group--error': $v.formData.state.$error }"
        >
          <label for="firm_edit-state_input">State*</label>
          <custom-select-geolocation
            id="firm_edit-state_input"
            ref="selectState"
            :options="states"
            :custom-id="'states-item'"
            :class="states.length < 1 ? 'disabled' : ''"
            default="Select a state"
            @input="selectStates"
            @openSelect="closeOtherSelectFields($refs.selectState)"
          />
          <select
            v-show="false"
            v-model="$v.formData.city.$model"
            :disabled="states.length < 1"
          >
            <option selected value disabled>
              Select a state
            </option>
            <option
              v-for="(state, indx) in states"
              :key="indx"
              :value="state.iso2"
            >
              {{ state.name }}
            </option>
          </select>
          <div v-if="!$v.formData.state.required" class="error">
            Field is required
          </div>
          <tooltip v-if="!isThereManageSystemPermission" :target-ref="$refs.manageSystemSettingsState">
            <span>For access to update company information - you need to have the permission 'Manage system settings'</span>
          </tooltip>
        </div>
        <div
          id="manage_system_settings-city"
          ref="manageSystemSettingsCity"
          class="form-group"
          :class="{ 'form-group--error': $v.formData.city.$error }"
        >
          <label for="firm_edit-city_input">City*</label>
          <custom-select-geolocation
            id="firm_edit-city_input"
            ref="selectCity"
            :options="cities"
            :class="cities.length < 1 ? 'disabled' : ''"
            :custom-id="'cities-item'"
            default="Select a city"
            @input="selectCities"
            @openSelect="closeOtherSelectFields($refs.selectCity)"
          />
          <select
            v-show="false"
            v-model="$v.formData.city.$model"
          >
            <option selected value disabled>
              Select a city
            </option>
            <option
              v-for="(cityItem, indx) in cities"
              :key="indx"
              :value="cityItem.name"
            >
              {{ cityItem.name }}
            </option>
          </select>
          <div v-if="cityError" class="error custom-error">
            {{ cityError }}
          </div>
          <div v-if="!$v.formData.city.required" class="error">
            Field is required
          </div>
          <tooltip v-if="!isThereManageSystemPermission" :target-ref="$refs.manageSystemSettingsCity">
            <span>For access to update company information - you need to have the permission 'Manage system settings'</span>
          </tooltip>
        </div>
        <div
          id="manage_system_settings-first-address"
          ref="manageSystemSettingsFirstAddress"
          class="form-group"
          :class="{ 'form-group--error': $v.formData.firstAddress.$error }"
        >
          <label for="firm_edit-first-adress_input" style="position: relative">
            Company Physical Address 1<span class="asterisk">*</span>
          </label>
          <input
            id="firm_edit-first-adress_input"
            v-model="$v.formData.firstAddress.$model"
            type="text"
            class="form-control"
            :disabled="!isThereManageSystemPermission"
            placeholder="Enter Physical Address"
          >
          <div v-if="firstAddressError" class="error custom-error">
            {{ firstAddressError }}
          </div>
          <div v-if="!$v.formData.firstAddress.required" class="error">
            Field is required
          </div>
          <div
            v-if="$v.formData.firstAddress.required
              && (!$v.formData.firstAddress.alphaNum || $v.formData.firstAddress.minLength || $v.formData.firstAddress.maxLength)"
            class="error"
          >
            First address should have from {{ $v.formData.firstAddress.$params.minLength.min }} to
            {{ $v.formData.firstAddress.$params.maxLength.max }} alphanumeric characters
          </div>
          <tooltip v-if="!isThereManageSystemPermission" :target-ref="$refs.manageSystemSettingsFirstAddress">
            <span>For access to update Company information - you need to have the permission 'Manage system settings'</span>
          </tooltip>
        </div>
        <div
          id="manage_system_settings-second-address"
          ref="manageSystemSettingsSecondAddress"
          class="form-group form-group-image"
          :class="{ 'form-group--error': $v.formData.secondAddress.$error }"
        >
          <label for="firm_edit-second-adress_input">Company Physical Address 2</label>
          <input
            id="firm_edit-second-adress_input"
            v-model="$v.formData.secondAddress.$model"
            type="text"
            class="form-control"
            :disabled="!isThereManageSystemPermission"
            placeholder="Enter Physical Address"
          >
          <div
            v-if="!$v.formData.secondAddress.alphaNum || $v.formData.secondAddress.minLength || $v.formData.secondAddress.maxLength"
            class="error"
          >
            Second address should have from {{ $v.formData.secondAddress.$params.minLength.min }} to
            {{ $v.formData.secondAddress.$params.maxLength.max }} alphanumeric characters
          </div>
          <tooltip v-if="!isThereManageSystemPermission" :target-ref="$refs.manageSystemSettingsSecondAddress">
            <span>For access to update Company information - you need to have the permission 'Manage system settings'</span>
          </tooltip>
        </div>
        <div
          id="manage_system_settings-postcode"
          ref="manageSystemSettingsPostcode"
          class="form-group"
          :class="{ 'form-group--error': $v.formData.postCode.$error }"
        >
          <label for="firm_edit-postcode_input">Postcode</label>
          <input
            id="firm_edit-postcode_input"
            v-model="$v.formData.postCode.$model"
            type="tel"
            class="form-control"
            :disabled="!isThereManageSystemPermission"
            placeholder="Enter postcode"
          >
          <div v-if="codeError" class="error custom-error">
            {{ codeError }}
          </div>
          <div v-if="!$v.formData.postCode.validPostcode" class="error">
            Invalid postcode for selected country
          </div>
          <tooltip v-if="!isThereManageSystemPermission" :target-ref="$refs.manageSystemSettingsPostcode">
            <span>For access to update company information - you need to have the permission 'Manage system settings'</span>
          </tooltip>
        </div>
        <div :class="this.validatePhoneStatus ? 'phone-wrapper not-valid' : 'phone-wrapper' ">
          <span class="otp-subtitle">Company Primary Phone Number*</span>
          <VuePhoneNumberInput
            id="register_phone-verify_input"
            ref="phoneInputRef"
            v-model="formData.phone"
            :required="false"
            :fetch-country="false"
            :no-validator-state="false"
            :error="validatePhoneStatus"
            :error-color="'#FF2E2E'"
            :valid-color="'#082655'"
            :border-radius="25"
            :default-country-code="'US'"
            @update="validatePhone"
          />
          <div v-if="validatePhoneStatus" class="phone-error" style="color:red;">
            Phone number is not valid
          </div>
        </div>
        <div class="text-editor-wrapper">
          <h2>Email template for Users</h2>
          <p class="editor-decr">
            If you would like to personalize the invitation letters for Users, enter the text below
            and we will attach
            it to each letter.
          </p>
          <p>Invitation message text *:</p>
          <RichTextEditor v-model="formData.userInviteText" :default-text="formData.userInviteText" />
        </div>
        <div class="text-editor-wrapper">
          <h2>Email template for Custodians</h2>
          <p class="editor-decr">
            If you would like to personalize the invitation letters for Custodians, enter the text
            below and we will attach it to each letter.
          </p>
          <p>Invitation message text *:</p>
          <RichTextEditor v-model="formData.clientInviteText" :default-text="formData.clientInviteText" />
        </div>
        <div class="save-btn-wrapper">
          <div id="manage_system_settings-save" ref="saveFirmInfoProfile" class="form-group">
            <button
              id="save_firm_info_profile"
              :disabled="!hasPermission(['manage_system_settings']) || isSending"
              class="btn profile-btn"
            >
              Save
            </button>
            <tooltip v-if="!isThereManageSystemPermission" :target-ref="$refs.saveFirmInfoProfile">
              <span>For access to update company information - you need to have the permission 'Manage system settings'</span>
            </tooltip>
          </div>
        </div>
      </form>
    </div>
    <CommonDialog ref="commonDialogFormSuccess">
      <SuccessIcon />
      <h2 class="dialog-message-title">
        Success!
      </h2>
      <p class="dialog-message-description" style="display:block;">
        Your company information has been changed
      </p>
    </CommonDialog>
    <CommonDialog v-if="newBillingContact" ref="changeBillingSuccessDialog">
      <SuccessIcon />
      <h2 class="dialog-message-title">
        Success!
      </h2>
      <div class="dialog-message-description">
        <span>The invitation for new billing contact was sent to:</span>
        <div v-if="typeof newBillingContact !== 'string'" class="contact-user-item">
          <div class="avatar-wrapper">
            <img v-if="newBillingContact.avatar" :src="newBillingContact.avatar" alt="">
            <img
              v-else
              :src="'https://cdn4.iconfinder.com/data/icons/avatars-xmas-giveaway/128/girl_female_woman_avatar-512.png'"
              alt=""
            >
          </div>
          {{ newBillingContact.firstName + " " + newBillingContact.lastName }}
        </div>
        <div v-else class="contact-user-item-email">
          {{ newBillingContact }}
        </div>
        <div>
          You will receive notification of approval within 24 hours. Contact customer support if you still have
          questions.
        </div>
      </div>
    </CommonDialog>
    <CommonDialog v-if="newCompanyOwner" ref="changeOwnerSuccessDialog">
      <SuccessIcon />
      <h2 class="dialog-message-title">
        Success!
      </h2>
      <div class="dialog-message-description" style="display:block;">
        The invitation for new primary contact was sent to:
        <div v-if="typeof newCompanyOwner !== 'string'" class="contact-user-item">
          <div class="avatar-wrapper">
            <img v-if="newCompanyOwner.avatar" :src="newCompanyOwner.avatar" alt="">
            <img
              v-else
              :src="'https://cdn4.iconfinder.com/data/icons/avatars-xmas-giveaway/128/girl_female_woman_avatar-512.png'"
              alt=""
            >
          </div>
          {{ newCompanyOwner.firstName + " " + newCompanyOwner.lastName }}
        </div>
        <div v-else class="contact-user-item-email">
          {{ newCompanyOwner }}
        </div>
        <div>
          You will receive notification of approval within 24 hours. Contact customer support if you still have
          questions.
        </div>
      </div>
    </CommonDialog>
    <ChangeContactPopup
      ref="changePrimaryPopup"
      is-primary-contact
      :contacts="contacts"
      @selectedContact="newCompanyOwner = $event"
      @completed="updateCompanyOwner()"
    />
    <ChangeContactPopup
      ref="changeBillingPopup"
      :contacts="contacts"
      @selectedContact="newBillingContact = $event"
      @completed="updateBillingContact()"
    />
  </div>
</template>

<script>
import VuePhoneNumberInput from 'vue-phone-number-input';
import HeaderMyProfile from '../layout/HeaderMyProfile';
import CommonDialog from '../popups/CommonDialog';
import CustomSelectGeolocation from '../inputs/CustomSelectGeolocation';
import {minLength, maxLength, helpers} from 'vuelidate/lib/validators';
import AlertErrorMsg from './AlertErrorMsg';
import hasPermission from '../../utils/permission';
import Tooltip from '@/components/common/Tooltip.vue';
import TableHeader from '@/components/table/TableHeader.vue';
import UserIcon from '@/components/icons/UserIcon.vue';
import EmailIcon from '@/components/icons/EmailIcon.vue';
import ChangeContactPopup from '@/components/popups/ChangeContactPopup.vue';
import RichTextEditor from '@/components/inputs/RichTextEditor.vue';
import {postcodeValidator} from 'postcode-validator';
import SuccessIcon from '@/components/icons/SuccessIcon.vue';
import capitalizeFirstLetter from '@/mixins/capitalizeFirstLetter';

const alphaNumS = helpers.regex('alpha', /^[a-zA-Z0-9\s#\-.(),/]*$/);

let apiKey = 'N3dGUHNibjUyRUJKR2pTQzlMMEdVUlpsQmZvYVFISEhITExtcmt4Vw==';

var headers = new Headers();
headers.append('X-CSCAPI-KEY', apiKey);

var requestOptions = {
  method: 'GET',
  headers: headers,
  redirect: 'follow'
};

export default {
  components: {
    SuccessIcon,
    RichTextEditor,
    ChangeContactPopup,
    EmailIcon,
    UserIcon,
    TableHeader,
    Tooltip,
    AlertErrorMsg,
    HeaderMyProfile,
    CommonDialog,
    CustomSelectGeolocation,
    VuePhoneNumberInput,
  },
  data() {
    return {
      isSending: false,
      firmData: null,
      contacts: null,
      providedFile: null,
      newCompanyOwner: null,
      newBillingContact: null,
      firmNameMax: 100,
      countries: [],
      cities: [],
      states: [],
      stateCode: '',
      countryCode: '',
      cityCode: '',
      companyId: null,
      formData: {
        firmName: '',
        state: '',
        country: '',
        city: '',
        firstAddress: '',
        secondAddress: '',
        postCode: '',
        phone: '',
        userInviteText: '',
        clientInviteText: '',
      },
      errorMessage: '',
      cityError: '',
      codeError: '',
      countryError: '',
      firmNameError: '',
      firstAddressError: '',
      validatePhoneStatus: false,
    };
  },
  computed: {
    isThereManageSystemPermission() {
      return this.hasPermission(['manage_system_settings']);
    },
    selectFieldsArray() {
      return [this.$refs.selectCountry, this.$refs.selectState, this.$refs.selectCity];
    },
  },
  validations: {
    formData: {
      firmName: {
        minLength: minLength(3),
        maxLength: maxLength(250),
        // required,
      },
      country: {
        // required,
      },
      city: {
        // required,
      },
      state: {
        // required,
      },
      firstAddress: {
        // required,
        minLength: minLength(5),
        maxLength: maxLength(250),
        alphaNumS,

      },
      secondAddress: {
        minLength: minLength(5),
        maxLength: maxLength(250),
        alphaNumS,
      },
      postCode: {
        validPostcode: function (value) {
          if (!value || !this.countryCode) return false;
          return postcodeValidator(value, this.countryCode);
        }
      },
    },
  },
  mixins: [capitalizeFirstLetter],
  mounted() {
    this.getFirmData();

    fetch('https://api.countrystatecity.in/v1/countries', requestOptions)
      .then(response => response.json())
      .then(result => {
        this.countries = this.filtering(result);
        this.countryCode = this.countries.find(country =>
          country.name.toLowerCase() === this.firmData.country.toLowerCase()).iso2;
      })
      .catch(error => console.log('error', error));

    const input = this.$refs.phoneInputRef.$refs.PhoneNumberInput.$refs.InputTel;
    input.placeholder = '(000) 000 00 00';
    this.getContacts();
  },
  methods: {
    validatePhone(event) {
      event.isValid ? this.validatePhoneStatus = false : this.validatePhoneStatus = true;
      if (event.isValid) {
        this.formData.phone = event.formattedNumber;
      }
    },
    filtering(arr) {
      return arr.sort((a, b) => a.name > b.name ? 1 : -1);
    },
    hasPermission,
    openDialogFormSuccess() {
      this.$refs.commonDialogFormSuccess.openPopups();
    },
    resetForm() {
      Object.keys(this.formData).forEach((key) => {
        this.formData[key] = null;
      });
      this.$refs.selectCountry.clearField();
      this.$refs.selectState.clearField();
      this.$refs.selectCity.clearField();
      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    selectCountry(code, value) {
      if (!value) return;
      this.resetSelectFields(true);
      this.countryCode = code;
      this.formData.country = value;
      this.getStates(code);
    },
    selectCities(code, value) {
      if (!value) return;
      this.cityCode = code;
      this.formData.city = value;
    },
    selectStates(code, value) {
      if (!value) return;
      this.stateCode = code;
      this.formData.state = value;
      this.getCity(this.countryCode, code);
    },
    resetSelectFields(withStates) {
      if (withStates) {
        this.cities = [];
        this.$refs.selectState.clearField();
        this.formData.state = '';
      }
      this.states = [];
      this.$refs.selectCity.clearField();
      this.formData.city = '';
    },
    closeOtherSelectFields(ref) {
      for (const fieldRef of this.selectFieldsArray) {
        if (fieldRef !== ref) fieldRef.closeSelect();
      }
    },
    getStates(codeCountries) {
      fetch(`https://api.countrystatecity.in/v1/countries/${codeCountries}/states/`, requestOptions)
        .then(response => response.json())
        .then(result => this.states = this.filtering(result))
        .catch(error => console.log('error', error));
    },
    getCity(codeCountries, codeStates) {
      fetch(`https://api.countrystatecity.in/v1/countries/${codeCountries}/states/${codeStates}/cities`, requestOptions)
        .then(response => response.json())
        .then(result => this.cities = this.filtering(result))
        .catch(error => console.log('error', error));
    },
    getFirmData() {
      this.$load(async () => {
        const res = await this.$api.profile.getFirm();
        this.companyId = res.data.body.id;
        this.firmData = res.data.body;
        this.formData.userInviteText = res.data.body.userInviteText;
        this.formData.clientInviteText = res.data.body.clientInviteText;
      }, (error) => {
        this.errorMessage = error.data.errors.message[0];
        this.$refs.alert.showAlert();
      });
    },
    updateBillingContact() {
      const email = typeof this.newBillingContact === 'string'
        ? this.newBillingContact
        : this.newBillingContact.email;
      this.$load(async () => {
        await this.$api.profile.updateBillingContact({
          email: email,
        }, this.firmData.id).then(() => {
          this.$refs.changeBillingSuccessDialog.openPopups();
          this.getFirmData();
        });
      }, (error) => {
        this.errorMessage = error.data.errors.message[0];
        this.$refs.alert.showAlert();
      });
    },
    updateCompanyOwner() {
      const email = typeof this.newCompanyOwner === 'string'
        ? this.newCompanyOwner
        : this.newCompanyOwner.email;
      this.$load(async () => {
        await this.$api.profile.updateCompanyOwner({
          email: email,
        }, this.firmData.id).then(() => {
          this.$refs.changeOwnerSuccessDialog.openPopups();
          this.getFirmData();
        });
      }, (error) => {
        this.errorMessage = error.data.errors.message[0];
        this.$refs.alert.showAlert();
      });
    },
    submit() {
      Object.keys(this.formData).forEach((key) => {
        if (!this.formData[key] || !this.formData[key].length) {
          this.formData[key] = this.firmData[key];
        }
      });

      this.$v.$touch();
      if (this.$v.$invalid) {
        this.isSending = false;
      } else {
        this.isSending = true;

        this.$load(async () => {
          await this.$api.profile.updateFirm(this.formData, this.companyId).then(() => {
            this.openDialogFormSuccess();
            this.getFirmData();
            this.resetForm();
            this.isSending = false;
          });
        }, (error) => {
          this.isSending = false;
          if (error) {
            if (error.response) {
              this.errorMessage = Object.values(error.response.data.errors).flat().slice(1).join('; ');
              this.$refs.alert.showAlert();
            } else {
              const {city, code, country, firmName, firstAddress} = error.data.errors;

              this.cityError = city && city + '';
              this.codeError = code && code + '';
              this.countryError = country && country + '';
              this.firmNameError = firmName && firmName + '';
              this.firstAddressError = firstAddress && firstAddress + '';

              setTimeout(() => {
                this.cityError = '';
                this.codeError = '';
                this.countryError = '';
                this.firmNameError = '';
                this.firstAddressError = '';
              }, 3000);
            }
          }
        });
      }
    },
    getContacts() {
      this.$load(async () => {
        await this.$api.contacts.getContactEmployees({
          sortBy: 'userName',
          order: 'asc',
          page: 1,
          size: 100,
          contactName: '',
          caseId: '',
          role: '',
        })
          .then((response) => {
            this.contacts = response.data.body.content;
          });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
img {
  max-width: 100%;
  max-height: 100%;
}

.label-file {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: 5px;
  right: -15px;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background-color: var(--accent-color);
}

input[type="file"] {
  display: none;
}

.holder-text {
  display: flex;
  flex-direction: column;
}

.profile-name {
  margin-bottom: 18px;
  color: var(--secondary-black-color);
  font-weight: 700;
  font-size: 22px;
}

.profile-desc {
  margin-bottom: 24px;
  color: var(--secondary-black-color);
  font-weight: 400;
  font-size: 12px;
}

.profile-desc span:first-child {
  text-transform: uppercase;
  font-weight: 500;
  font-size: 16px;
}

.profile-desc span:last-child {
  text-transform: uppercase;
  font-weight: 700;
  font-size: 10px;
}

.profile-contacts {
  display: flex;
  flex-direction: column;
  list-style: none;
}

.profile-contacts li {
  display: flex;
  align-items: center;
  font-size: 12px;
  font-weight: 400;
  margin-bottom: 18px;
  color: var(--secondary-black-color);
}

.profile-contacts svg {
  margin-right: 20px;
}

.holder-profile-form {
  font-weight: 500;
  font-size: 16px;
  color: var(--secondary-text-color);

  p {
    margin-bottom: 40px;
    color: var(--light-gray);
  }
}

.profile-form {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.profile-form .form-group, .profile-btn {
  width: calc(50% - 30px);
}

.profile-btn {
  max-width: 400px;
  width: 100%;
  padding: 14px;
  margin-top: 20px;
  border-radius: 25px;
}

.dialog-message-title {
  font-style: normal;
  font-weight: bold;
  font-size: 30px;
  line-height: 36px;
  color: #292B2F;
  text-align: center;
  margin: 25px 0 0 0;
  display: block;
  width: 100%;
  text-transform: capitalize;
}

.dialog-message-description {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 26px;
  text-align: center;
  color: #696F79;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  width: 100%;
  margin: 20px 0;

  span {
    color: var(--secondary-black-color);
  }
}

.phone-error {
  font-style: normal;
  font-weight: 500;
  font-size: 10px;
  line-height: 12px;
  color: var(--alert-color);
  display: block;
  margin: 10px 0;
}

.phone-wrapper {
  width: calc(50% - 30px);
}

.asterisk {
  position: absolute;
  top: 0;
}

.primary-contact-wrapper {
  display: flex;
  flex-direction: column;
  margin: 0 0 32px;

  .contact-name-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;

    .contact-name {
      display: flex;
      align-items: center;
      gap: 15px;

      p {
        font-size: 26px;
        font-weight: 700;
        line-height: 39px;
        text-align: left;
        color: var(--accent-color);
        margin: 0;
      }
    }

    button {
      max-width: 300px;
      width: 100%;
      height: 35px;
      border-radius: 40px;
      border: 1px solid #082655;
      gap: 10px;

      svg path {
        fill: var(--accent-color);
      }

      &:hover svg path {
        fill: var(--white-color);
      }
    }
  }
}

.table-header {
  max-height: 54px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 15px 0 15px 22px;
}

.table-header.active {
  justify-content: space-between;
  padding-right: 13px;
  background-color: var(--accent-color);
}

.table-header-box {
  cursor: default;
}

.table-header-box:hover .header-table-text {
  text-decoration: none;
}

.card {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  padding: 10px 18px;
  gap: 15px;
}

.name, .phone, .email {
  max-width: 33%;
  width: 100%;
}

.table-body {
  min-height: 65px;
}

.contact-user-item {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.contact-user-item-email {
  background: #EBEFF6;
  border-radius: 16px;
  padding: 0 10px;
}

.avatar-wrapper {
  width: 35px;
  height: 35px;
  padding: 5px;
}

.avatar-wrapper img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}

.text-editor-wrapper {
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 560px;

  h2 {
    margin: 0;
  }

  p {
    margin: 0;
    font-size: 14px;
    font-weight: 500;
    line-height: 16.94px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: var(--secondary-black-color);
  }

  .editor-decr {
    font-size: 16px;
    line-height: 25.6px;
    color: var(--light-gray);
  }
}

h2 {
  font-size: 14px;
  font-weight: 700;
  line-height: 21px;
  letter-spacing: 0.03em;
  text-align: left;
  color: var(--secondary-black-color);
  text-transform: uppercase;
}

.save-btn-wrapper {
  width: 100%;
  margin: 0 0 50px 0;
}

</style>
